export const getMediaUrl = (path, fallback) => {
  if (!path) return fallback;
  if (path.startsWith('http')) return path;
  
  // In development, we might want to use the full URL if NOT proxied correctly
  // but for production/docker, relative path is better
  return `/media/${path}`;
};
